import * as THREE from 'three';

let isMobileDevice = false;

export const GetIsMobileDevice = () => {
    return isMobileDevice;
}

export const setupRenderer = (canvas, sizes) => {
    const cores = navigator.hardwareConcurrency;
    const memory = navigator.deviceMemory;

    // console.log('cores: ', cores);
    // console.log('memory: ', memory);
    const uaInfo = parseUserAgent();
    // console.log("OS:", uaInfo.os);
    // console.log("Browser:", uaInfo.browser);
    // console.log("User Agent:", uaInfo.userAgent);

    let isAntialias = true;
    let setPixelRatio = 1;

    if ((uaInfo.os === "Windows" || uaInfo.os === "Mac OS")) {
        // 성능이 괜찮은 PC 또는 맥일경우 
        // if (cores > 6 && memory > 4)
        //     console.log('%c성능좋음', "color: green; font-weight: bold;");
        // console.log('%c데스크톱', "color: green; font-weight: bold;");
    }
    else {
        isMobileDevice = true;
        isAntialias = true;
        setPixelRatio = 1;
        // console.log('%c모바일이거나 성능 안좋음', "color: red; font-weight: bold;");
    }

    const renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        alpha: true,
        antialias: isAntialias,
        powerPreference: 'high-performance'
    });
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, setPixelRatio));
    renderer.setClearColor(0xffffff, 0);
    renderer.shadowMap.enabled = true;
    // renderer.shadowMap.type = THREE.VSMShadowMap;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    // renderer.shadowMap.type = THREE.BasicShadowMap;

    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.0;

    const pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();
    return { renderer, pmremGenerator };
};

const Render = (scene, camera, renderer) => {
    if (renderer)
        renderer.render(scene, camera);
}

export const Update = (scene, camera, renderer, update) => {
    const loop = () => {
        requestAnimationFrame(loop);
        Render(scene, camera, renderer);

        if (update)
            update();
    };

    loop(); // 루프 시작
};

export const ResizeScreen = (renderer, sizes, camera) => {
    // console.log("resize")

    var ratioValue = window.innerWidth / window.innerHeight;
    // console.log(`ratio : ${ratioValue}`);
    // if (ratioValue > 1.912) return;

    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;
    camera.aspect = sizes.width / sizes.height;

    camera.updateProjectionMatrix();
    if (ratioValue > 1.912) {
        renderer.setPixelRatio(1.912, 1);
    } else
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1));
    renderer.setSize(sizes.width, sizes.height);
}

const parseUserAgent = () => {
    const ua = navigator.userAgent;
    let os = "Unknown OS";
    let browser = "Unknown Browser";

    // 운영체제(OS) 분석
    if (/windows phone/i.test(ua)) {
        os = "Windows Phone";
    } else if (/win/i.test(ua)) {
        os = "Windows";
    } else if (/android/i.test(ua)) {
        os = "Android";
    } else if (/linux/i.test(ua)) {
        os = "Linux";
    } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
        os = "iOS";
    } else if (/mac/i.test(ua)) {
        os = "Mac OS";
    }

    // 브라우저 분석
    if (/chrome/i.test(ua) && !/edge/i.test(ua) && !/opr/i.test(ua)) {
        browser = "Chrome";
    } else if (/safari/i.test(ua) && !/chrome/i.test(ua)) {
        browser = "Safari";
    } else if (/firefox/i.test(ua)) {
        browser = "Firefox";
    } else if (/edge/i.test(ua)) {
        browser = "Edge";
    } else if (/opr/i.test(ua)) {
        browser = "Opera";
    } else if (/trident/i.test(ua)) {
        browser = "Internet Explorer";
    }

    return { os, browser, userAgent: ua };
}